export const DialogMessageTypeClasses = {
    dialog: "rj-dialog-message--dialog",
    notification: "rj-dialog-message--notification"
};
export const DialogMessageButtonClasses = {
    default: "rj-dialog-message__btn--default",
    negative: "rj-dialog-message__btn--negative",
    positive: "rj-dialog-message__btn--positive" //green
};
export const DialogMessageDefaultConfig = {
    header: "",
    body: "",
    closeBtn: true,
    type: DialogMessageTypeClasses.notification,
    className: "",
    actions: {}
};
//# sourceMappingURL=DialogMessageConstants.js.map